import { SkillConfigSchema } from "@redotech/redo-model/shopper-agent/skill-config";
import { SkillId } from "@redotech/redo-model/shopper-agent/skill-id";
import * as z from "zod";

export const updateShopperAgentSkill = {
  name: "updateShopperAgentSkill" as const,
  input: z.object({
    skillId: z.enum(SkillId),
    config: SkillConfigSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
